import { ARRAY_ELEMENT_ID } from '@cash-rewards/mparticlejs';
import {
  offerClickEventMapper,
  offerProductMapper
} from '@cash-rewards/reactjs/client';

import ShopCarousel from '@/modules/core/components/shopCarousel/ShopCarousel';
import OfferCarouselAdCard from '@/modules/shop/components/offers/OfferCarouselAdCard';
import OfferCarouselCard from '@/modules/shop/components/offers/OfferCarouselCard';
import { Offer } from '@/modules/shop/models/offerModels';

interface FeaturedOffersProps {
  offers: Offer[];
  algorithmVersion?: string;
  experimentIds?: string;
}

const FeaturedOffers = ({
  offers,
  algorithmVersion,
  experimentIds,
  ...rest
}: FeaturedOffersProps) => {
  return (
    <ShopCarousel
      title={"Offers you won't want to miss"}
      navigationButtonTopCss='top-28'
      data-test-id='featured-offers-carousel'
      items={offers}
      productMappers={[offerProductMapper]}
      carouselType={ARRAY_ELEMENT_ID.featured_offers}
      clickEventMappers={[offerClickEventMapper]}
      customAttributeOverrides={{
        personalisation_ids: algorithmVersion,
        experiment_ids: experimentIds
      }}
      {...rest}
    >
      {offers.map((offer) => {
        return !offer.isAdvert ? (
          <OfferCarouselCard
            key={offer.id}
            offer={offer}
            data-test-id={`offer-card-box-${offer.id}`}
            className='mr-cr-4 lg:mr-cr-8'
          ></OfferCarouselCard>
        ) : (
          <OfferCarouselAdCard
            key={offer.id}
            offer={offer}
            data-test-id={`offer-card-box-ad-${offer.id}`}
            className='mr-cr-4 lg:mr-cr-8'
          ></OfferCarouselAdCard>
        );
      })}
    </ShopCarousel>
  );
};

export default FeaturedOffers;
